export default __webpack_public_path__ + "static/media/slow picking.54f33aef.jpg";